import { ApiDatasource } from '../../adapters/io/datasources/ApiDatasource';
import { unwrap } from '../../adapters/io/network/HttpResponse';
import { formatText } from '../../adapters/io/network/utils';
import { ApiDatasourceSpec } from '../../core/datasource';
import { ChannelTableStructure } from '../indexes/ChannelIndexes';
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';

export const getChannelRecords = <T>(
    authState: AuthState,
    page?: number,
    limit?: number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<ChannelTableStructure.ResponseOf<T>> => {

    const params = new Map();

    if (page) {
        params.set('page', page);
        params.set('limit', limit);
    }

    return datasource.remote
        .getData<ChannelTableStructure.ResponseOf<T>>(uriFormatter(EndpointChannel.endPoint.concat(EndpointChannel.getChannelRecords), {}), buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointChannel = {
    endPoint: '/end-point',
    getChannelRecords: '/channel'
};